import React from 'react'
import { useMapboxMap } from '../../hooks/useMapboxMap'
import { useMapClickHandlers } from '../../hooks/useMapClickHandlers'
import { MapboxMapProvider } from '../../contexts/MapboxMapContext'

interface MapboxMapCoreProps {
  onRouteClick?: (route: any) => void
  onWaypointClick?: (waypoint: any) => void
  onPOIClick?: (poi: any) => void
  onMapClick?: (coords: [number, number]) => void
  height?: string
  className?: string
  children?: React.ReactNode
  styleUrl?: string
  /** If false, scroll/wheel over the map will not zoom (page scrolls instead). Default true. */
  scrollZoom?: boolean
}

/**
 * Core Mapbox map component that handles initialization and click handlers
 * This is the foundation that other components build upon
 * Provides map context to children for layer management
 */
export function MapboxMapCore({
  onRouteClick,
  onWaypointClick,
  onPOIClick,
  onMapClick,
  height = '400px',
  className = '',
  children,
  styleUrl,
  scrollZoom
}: MapboxMapCoreProps) {
  const { map, mapContainer, isLoaded, styleLoaded } = useMapboxMap({
    styleUrl,
    scrollZoom
  })
  
  // Setup click handlers
  useMapClickHandlers({
    map,
    isLoaded,
    styleLoaded,
    onRouteClick,
    onWaypointClick,
    onPOIClick,
    onMapClick
  })

  return (
    <MapboxMapProvider map={map} isLoaded={isLoaded} styleLoaded={styleLoaded}>
      <div 
        ref={mapContainer} 
        className={`w-full ${className}`}
        style={{ height }}
      />
      {children}
    </MapboxMapProvider>
  )
}

